import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * shadcn/ui : merge de classes Tailwind avec dédoublonnage intelligent.
 * Usage : `cn('p-2', condition && 'p-4', overrideClass)` → la dernière gagne.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
